export const MARKER_URL_BY_VERSION = (version = 'v1') => `${process.env.MARKER_URL}/${version}/marker`;
